import React from 'react'
import PropTypes from 'prop-types'
import classes from './SelectCell.module.css'

const SelectCell = ({ value, onChange, options }) => {
  const isValidValue = value in options

  return (
    <select
      value={isValidValue ? value : ''}
      onChange={e => onChange(e.target.value)}
      className={classes.select}
    >
      {!isValidValue && (
        <option value="" disabled hidden>
          -
        </option>
      )}

      {Object.entries(options).map(([key, label]) => (
        <option key={key} value={key}>
          {label}
        </option>
      ))}
    </select>
  )
}

SelectCell.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default SelectCell
